import { render } from "./BugFound.vue?vue&type=template&id=2639a505&scoped=true"
import script from "./BugFound.vue?vue&type=script&lang=js"
export * from "./BugFound.vue?vue&type=script&lang=js"

import "./BugFound.vue?vue&type=style&index=0&id=2639a505&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2639a505"]])

export default __exports__